import registerRoutes from './routes';

import getImportDetailsFactory from './services/import/getImportDetails';
import getImportRecordsFactory from './services/import/getImportRecords';
import getImportListFactory from './services/import/getImportList';
import uploadImportsFactory from './services/upload/uploadImports';

export default function (app) {
    /*   register services   */
    app.factory('getImportDetails', getImportDetailsFactory);
    app.factory('getImportRecords', getImportRecordsFactory);
    app.factory('getImportList', getImportListFactory);
    app.factory('uploadImports', uploadImportsFactory);

    registerRoutes(app);
}



// WEBPACK FOOTER //
// ./Client/app/data-import-export/index.js